module.exports = __webpack_public_path__ + "static/media/product5.1d568a9f.png";